import * as React from "react";
import styled from "styled-components";

const Text = styled.span`
  font-size: 1.5rem;
  font-family: ${({ theme }) => theme.font.highlight.family};
  font-weight: ${({ theme }) => theme.font.highlight.weight.regular};
`;

interface BorderTextProps {
  children?: React.ReactNode;
}

const BorderText = ({ children }: BorderTextProps) => {
  return <Text>{children}</Text>;
};

export default BorderText;
